import { SectionsTreeNode } from '../types';

/**
 * Recalculates numberOfPages and numberOfUnfilteredPages: leaves keep their values, parents sum
 * their children, and nodes with 0 pages are removed.
 */
export function recalculateNumberOfPages(nodes: SectionsTreeNode[]): SectionsTreeNode[] {
  return nodes
    .map((node): SectionsTreeNode | null => {
      let updatedChildren: SectionsTreeNode[] | undefined;

      if (node.children && node.children.length > 0) {
        updatedChildren = recalculateNumberOfPages(node.children);
      }

      let numberOfPages = 0;
      let numberOfUnfilteredPages = 0;

      if (updatedChildren && updatedChildren.length > 0) {
        numberOfPages = updatedChildren.reduce((acc, child) => acc + child.numberOfPages, 0);
        numberOfUnfilteredPages = updatedChildren.reduce((acc, child) => acc + child.numberOfUnfilteredPages, 0);
      } else if (node.pageIds && node.pageIds.length > 0) {
        numberOfPages = node.numberOfPages;
        numberOfUnfilteredPages = node.numberOfUnfilteredPages;
      }

      if (numberOfPages === 0) {
        return null;
      }

      return {
        ...node,
        numberOfPages,
        numberOfUnfilteredPages,
        children: updatedChildren?.length ? updatedChildren : undefined,
      };
    })
    .filter((node): node is SectionsTreeNode => node !== null);
}
